import { render, staticRenderFns } from "./collegeList.vue?vue&type=template&id=00923edf&scoped=true"
import script from "./collegeList.vue?vue&type=script&lang=js"
export * from "./collegeList.vue?vue&type=script&lang=js"
import style0 from "./collegeList.vue?vue&type=style&index=0&id=00923edf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00923edf",
  null
  
)

export default component.exports